console.log('v2.15')

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/assets/style/reset.css"

import store from "@/store/index.js"

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import SlideTip from "@/components/SlideTip.vue"
Vue.component('SlideTip', SlideTip)

import BackBtn from "@/components/BackBtn.vue"
Vue.component('BackBtn', BackBtn)

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.$publicPath = '/'
} else if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$publicPath = '/njmuseum/'
}
Vue.prototype.$backEndBaseUrl = 'https://culture.4dage.com/njmuseum/'

Vue.prototype.$oneRemToPx = window.innerHeight * 0.025276
document.documentElement.style.fontSize = Vue.prototype.$oneRemToPx + 'px'
window.addEventListener('resize', () => {
  Vue.prototype.$oneRemToPx = window.innerHeight * 0.025276
  document.documentElement.style.fontSize = Vue.prototype.$oneRemToPx + 'px'
})

document.documentElement.addEventListener('touchmove', function(event) {
  if (event.touches.length > 1) {
    event.preventDefault()
    event.stopPropagation()
  }
}, true)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
